import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';

import { QueryClient, QueryClientProvider } from 'react-query';
import App from './App';

import StoreProvider from './data/store/provider';
import CartContextProvider from './data/cart/provider';

const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <QueryClientProvider client={queryClient}>
        <StoreProvider>
          <CartContextProvider>
            <App />
          </CartContextProvider>
        </StoreProvider>
      </QueryClientProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);
